import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import _ = require('lodash');
import { Subject } from 'rxjs';
import { RiskEvaluationService } from '../../../services/risk-evaluation.service';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-risk-matrix',
  templateUrl: './risk-matrix.component.html',
  styleUrls: ['./risk-matrix.component.css']
})
export class RiskMatrixComponent implements OnInit {


  matrixForm: FormGroup;
  editmatrixForm: FormGroup;
  matrixMasterList: any[];
  evaluationTypeList: any[];
  evaluationCriteriaList: any[];
  evaluationType: any;
  matrixName: any;
  matrixID: any;
  matrixIdToDelete: any;
  editCriteriaId: any;
  evaluationevalCriteriaList: any[];
  disableSavebutton: boolean = false;
  disableupdatebutton: boolean = false;

  @ViewChild(DataTableDirective, { static: true })
  dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  dtTrigger: Subject<any> = new Subject();
  selectedValue: number;
  impactLabels = ['Trivial', 'Low', 'Medium', 'High', 'Critical'];
  probabilityLabels = ['Trivial', 'Low', 'Medium', 'High', 'Critical'];
  RiskMatrix: number;

  constructor(
    private router: Router,
    private alert: AlertComponent,
    private riskEvaluationService: RiskEvaluationService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.dtOptions = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      // scrollY: "440px",
      // scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pageLength: 10,
      search: true,
      language: {
        //made changes for datatables for next previous button
        paginate: {
          first: '<<',
          last: '>>',
          next: '>',
          previous: '<',
        },
      },
    };

    // Create a nested FormArray for a 5x5 matrix
    this.matrixForm = this.fb.group({
      matrix: this.fb.array(
        Array.from({ length: 5 }, () =>
          this.fb.array(Array(5).fill(''))
        )
      )
    });

    // Create a nested FormArray for a 5x5 matrix
    this.editmatrixForm = this.fb.group({
      matrix: this.fb.array(
        Array.from({ length: 5 }, () =>
          this.fb.array(Array(5).fill(''))
        )
      )
    });

    this.matrixForm = this.fb.group({
      matrixName: ['', Validators.required],
      selectedValue: [5, Validators.required],
      Results: this.fb.array(
        Array.from({ length: this.probabilityLabels.length }, () =>
          this.fb.array(Array(this.impactLabels.length).fill(''))
        )
      )
    });

    this.editmatrixForm = new FormGroup({
      RiskMatrix: new FormControl(5, [Validators.required]),
      MatrixName: new FormControl('', Validators.required),
      Results: this.fb.array(
        Array.from({ length: this.probabilityLabels.length }, () =>
          this.fb.array(Array(this.impactLabels.length).fill(''))
        )
      )
    });

    this.getRiskMatrixList();
    this.getEntityListDetails();
    this.getEvaluationCriteriaList();
  }

  getInputValueChange(event: Event): string {
    // @ts-ignore
    return (event.target ? (event.target as HTMLInputElement) : event).value;
  }

  getRiskMatrixList() {
    this.riskEvaluationService
      .getRiskMatrixList()
      .then((response) => {
        if (response.status == 0) {
          $('#riskMatrixTable').DataTable().destroy();
          if (_.size(response.matrixList)) {
            this.matrixMasterList = response.matrixList;
            this.dtTrigger.next();
          } else {
            this.matrixMasterList = [];
            this.dtTrigger.next();
          }
        } else {
          this.matrixMasterList = [];
          this.dtTrigger.next();
        }
      });
  }

  getEntityListDetails() {
    // this.matrixForm.reset();

    this.riskEvaluationService.getEvaluationTypeList().then((response) => {
      if (response.status == 0) {
        if (_.size(response.evalTypeList)) {
          this.evaluationTypeList = response.evalTypeList;
        } else {
          this.evaluationTypeList = [];
        }
      } else {
        this.evaluationTypeList = [];
      }
    });
  }

  showGetEntityListDetails() {
    // this.matrixForm.reset();
    //on click of button to show popup form..
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#matrixMasterModal').removeClass('show').hide();

    setTimeout(() => {
      $('#matrixMasterModal').modal('show');
    }, 100);
    this.riskEvaluationService.getEvaluationTypeList().then((response) => {
      if (response.status == 0) {
        if (_.size(response.evalTypeList)) {
          this.evaluationTypeList = response.evalTypeList;
        } else {
          this.evaluationTypeList = [];
        }
      } else {
        this.evaluationTypeList = [];
      }
    });
  }

  getEvaluationCriteriaList() {
    this.riskEvaluationService.getEvaluationCriteriaList().then((response) => {
      if (response.status == 0) {
        //console.log("criterialist new",response)
        if (_.size(response.evalCriteriaList)) {
          this.evaluationevalCriteriaList = response.evalCriteriaList;
        } else {
          this.evaluationevalCriteriaList = [];
        }
      } else {
        this.evaluationevalCriteriaList = [];
      }
    });
  }

  // getCriteriaListByEntityId(event) {
  //
  //   this.matrixForm.controls.matrixName.setValue("");
  //   this.matrixForm.controls.matrixName.updateValueAndValidity();
  //   var evaluationTypeId = event.target.value;
  //  //console.log("this.matrixForm.controls.matrixName.",this.matrixForm.controls.evaluationType.value)

  //   //console.log("event", event.target.value)
  //   this.riskEvaluationService.getEvaluationCriteriaByEvalIdList(evaluationTypeId).then(response => {
  //     if (response.status == 0) {
  //       if (_.size(response.evalCriteriaList)) {
  //         this.evaluationCriteriaList = response.evalCriteriaList;
  //       } else {
  //         this.evaluationCriteriaList = [];
  //       }
  //     } else {
  //       this.evaluationCriteriaList = [];
  //     }
  //   });
  // }

  // getCriteriaListByEntityIdForEditForm(event) {
  //
  //   this.editmatrixForm.controls.editEvaluationCriteria.setValue("");
  //   this.editmatrixForm.controls.editEvaluationCriteria.updateValueAndValidity();
  //   var evaluationTypeId = event.target.value;
  //  //console.log("this.matrixForm.controls.matrixName.",this.editmatrixForm.controls.editEvaluationCriteria.value)

  //   //console.log("event", event.target.value)
  //   this.riskEvaluationService.getEvaluationCriteriaByEvalIdList(evaluationTypeId).then(response => {
  //     if (response.status == 0) {
  //       if (_.size(response.evalCriteriaList)) {
  //         this.evaluationCriteriaList = response.evalCriteriaList;
  //       } else {
  //         this.evaluationCriteriaList = [];
  //       }
  //     } else {
  //       this.evaluationCriteriaList = [];
  //     }
  //   });
  // }

  closeForm() {
    this.ngOnInit();
  }

  submitMatrixDetails() {
    this.disableSavebutton = true;
    try {
      const self = this;

      var matrixObject = {
        MatrixName: this.matrixForm.controls.matrixName.value,
        Results: this.matrixForm.value.Results.flat(),
        RiskMatrix: this.matrixForm.controls.selectedValue.value,
      };

      this.riskEvaluationService.addRiskMatrix(matrixObject).then((response) => {
        this.disableSavebutton = false;

        if (response.status == 0) {
          $('#matrixMasterModal').modal('hide');
          this.alert.successWithOk1(response.message, () => {
            ////inside popup form dialog
            $('#matrixMasterModal').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');


          });
          this.messagePopUpTimeoutToogle();
          this.matrixForm.reset();
          this.getRiskMatrixList();
        } else {
          $('#matrixMasterModal').modal('hide');
          this.alert.error1(response.message, () => {
            ////inside popup form dialog
            $('#matrixMasterModal').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
          });

          this.messagePopUpTimeoutToogle();
          this.matrixForm.reset();
          this.getRiskMatrixList();
        }
      });
    } catch (error) { }
  }

  removeBackdrop() {
    // Manually remove any remaining modal backdrop
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }
  editQuestionDetails(selectedMatrix) {
    if (selectedMatrix != '') {
      this.matrixID = selectedMatrix;

      this.editCriteriaId = selectedMatrix.MatrixID;
      this.editmatrixForm.controls.MatrixName.setValue(
        selectedMatrix.MatrixName
      );
      this.editmatrixForm.controls.RiskMatrix.setValue(
        selectedMatrix.RiskMatrix
      );
    if (selectedMatrix.RiskMatrix === 3) {
      this.impactLabels = ['Low', 'Medium', 'High'];
      this.probabilityLabels = ['Low', 'Medium', 'High'];
    } else {
      this.impactLabels = ['Trivial', 'Low', 'Medium', 'High', 'Critical'];
      this.probabilityLabels = ['Trivial', 'Low', 'Medium', 'High', 'Critical'];
    }
      this.editmatrixForm.controls.RiskMatrix.updateValueAndValidity();
      this.editmatrixForm.controls.MatrixName.updateValueAndValidity();
      const size = selectedMatrix.Results.length === 9 ? 3 : 5;
      const matrix2D = this.reshapeFlatArrayToMatrix(selectedMatrix.Results, size);
      this.editmatrixForm.setControl('Results', this.buildResultsFormArray(size));
      matrix2D.forEach((row, i) => {
        row.forEach((value, j) => {
          (this.editmatrixForm.get('Results') as FormArray).at(i).get([j]).setValue(value);
        });
      });

      $('#editingQuestionModal').modal('toggle');
    } else {
      $('#alertPopUpTitle').css('color', '#f00');
      $('#alertPopUpTitle').text('Failure!');
      $('#alertMessage').text('Matrix Selection Failure');
      $('#alertMessage').css('color', '#f00');
      $('#messagePopUp').modal('toggle');
      this.messagePopUpTimeoutToogle();
    }
  }

  udpateQuestionDetails() {
    this.disableupdatebutton = true;
    const self = this;

    var matrixObject = {
      MatrixID: this.matrixID._id,
      MatrixName: this.editmatrixForm.controls.MatrixName.value,
      RiskMatrix: this.editmatrixForm.controls.RiskMatrix.value,
      Results: this.editmatrixForm.value.Results.flat()
    };

    this.riskEvaluationService
      .updateEvaluationMatrix(matrixObject)
      .then((response) => {
        this.disableupdatebutton = false;
        if (response.status == 0) {
          $('#riskMatrixTable').DataTable().destroy();
          $('#editingQuestionModal').modal('toggle');
          $('#alertPopUpTitle').text('Success!');
          $('#alertPopUpTitle').css('color', 'black');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', 'black');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getRiskMatrixList();
          this.editmatrixForm.reset();
        } else {
          $('#riskMatrixTable').DataTable().destroy();
          $('#editingQuestionModal').modal('toggle');
          $('#alertPopUpTitle').text('Failure!');
          $('#alertPopUpTitle').css('color', '#f00');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', '#f00');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getRiskMatrixList();
          this.editmatrixForm.reset();
        }
      });
  }

  editRiskMatrixChange(event) {
    if (event.target.value.trim() == '') {
      this.editmatrixForm.controls.editMatrixText.setValue(
        event.target.value.trim()
      );
      this.editmatrixForm.controls.editMatrixText.updateValueAndValidity();
    }
  }



  deleteQuestionIdToPass(matrix) {
    this.matrixIdToDelete = matrix._id;
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#deleteQuestionMasterModal').removeClass('show').hide();

    setTimeout(() => {
      $('#deleteQuestionMasterModal').modal('show');
    }, 100);
  }

  deleteQuestionDetails() {
    //console.log(" this.matrixIdToDelete", this.matrixIdToDelete);
    this.riskEvaluationService.deleteMatrix(this.matrixIdToDelete)
      .then((response) => {
        // Hide the modal and remove any remaining backdrops
        $('#deleteQuestionMasterModal').modal('toggle');
        this.removeBackdrop(); // Manually remove any leftover backdrops

        // Set alert details based on response status
        const isSuccess = response.status == 0;
        const alertColor = isSuccess ? 'black' : '#f00';
        const alertTitle = isSuccess ? 'Success!' : 'Failure!';

        // $('#alertPopUpTitle').text(alertTitle).css('color', alertColor);
        // $('#alertMessage').text(response.message).css('color', alertColor);
        // ////inside popup form dialog
        // $('#deleteQuestionMasterModal').off('hidden.bs.modal');
        // $('.modal-backdrop').remove();
        // $('body').removeClass('modal-open');
        // $('#deleteQuestionMasterModal').modal('hide');
        // this.messagePopUpTimeoutToogle();

        // Refresh Dept list
        this.getRiskMatrixList();
        this.getEntityListDetails();
      });
  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == 'modal fade show') {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  editCriteria(event) {
    //console.log("event", event.target.value)
  }
  onRiskMatrixChange(event: any) {
    this.selectedValue = 3;
    this.impactLabels = ['Low', 'Medium', 'High'];
    this.probabilityLabels = ['Low', 'Medium', 'High'];
    this.matrixForm.setControl('Results', this.buildResultsFormArray(3));
  }

  onRiskMatrixChange1(event: any) {
    this.selectedValue = 5;
    this.impactLabels = ['Trivial', 'Low', 'Medium', 'High', 'Critical'];
    this.probabilityLabels = ['Trivial', 'Low', 'Medium', 'High', 'Critical'];
    this.matrixForm.setControl('Results', this.buildResultsFormArray(5));
  }

  onEditRiskMatrixChange(event: any) {
    this.RiskMatrix = 3;
    this.impactLabels = ['Low', 'Medium', 'High'];
    this.probabilityLabels = ['Low', 'Medium', 'High'];
    this.editmatrixForm.setControl('Results', this.buildResultsFormArray(3));
  }

  onEditRiskMatrixChange1(event: any) {
    this.RiskMatrix = 5;
    this.impactLabels = ['Trivial', 'Low', 'Medium', 'High', 'Critical'];
    this.probabilityLabels = ['Trivial', 'Low', 'Medium', 'High', 'Critical'];
    this.editmatrixForm.setControl('Results', this.buildResultsFormArray(5));
  }

  matrixFormRiskMatrixChange(event: any) {
    if (this.matrixForm.controls.matrixName.value.trim() == '') {
      this.matrixForm.controls.matrixName.setValue(
        this.matrixForm.controls.matrixName.value.trim()
      );
      this.matrixForm.controls.matrixName.updateValueAndValidity();
    }
  }

  private buildResultsFormArray(size: number): FormArray {
    return this.fb.array(
      Array.from({ length: size }, () =>
        this.fb.array(Array(size).fill(''))
      )
    );
  }

  private reshapeFlatArrayToMatrix(flat: any[], size: number): any[][] {
    const matrix = [];
    for (let i = 0; i < size; i++) {
      matrix.push(flat.slice(i * size, (i + 1) * size));
    }
    return matrix;
  }

  editmatrixFormRiskMatrixChange(event: any) {
    if (this.editmatrixForm.controls.editMatrixText.value.trim() == '') {
      this.editmatrixForm.controls.editMatrixText.setValue(
        this.editmatrixForm.controls.editMatrixText.value.trim()
      );
      this.editmatrixForm.controls.editMatrixText.updateValueAndValidity();
    }
  }


}



